__turbopack_context__.v({
  "actionButtons": "privacy-notice-dialog-module-scss-module__eRquVa__actionButtons",
  "actions": "privacy-notice-dialog-module-scss-module__eRquVa__actions",
  "body": "privacy-notice-dialog-module-scss-module__eRquVa__body",
  "content": "privacy-notice-dialog-module-scss-module__eRquVa__content",
  "footerNote": "privacy-notice-dialog-module-scss-module__eRquVa__footerNote",
  "html": "privacy-notice-dialog-module-scss-module__eRquVa__html",
  "loader": "privacy-notice-dialog-module-scss-module__eRquVa__loader",
  "mantineBody": "privacy-notice-dialog-module-scss-module__eRquVa__mantineBody",
  "scrollArea": "privacy-notice-dialog-module-scss-module__eRquVa__scrollArea",
});
